import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { SuspenseDebounceLoader } from '@paysera/react-common';
import store from './store';

export const WrapperReduxStore = ({ children }) => (
    <Suspense fallback={<SuspenseDebounceLoader />}>
        <Provider store={store}>
            {children}
        </Provider>
    </Suspense>
);

WrapperReduxStore.propTypes = {
    children: PropTypes.node.isRequired,
};
